import {makeStyles} from '@material-ui/core/styles';

export default() =>{

    const useStyles = makeStyles ({
 
        header: {
          padding: "20px !important",
          FlexDirection: "row",
          marginTop: "px",
          TextAlign: "rigt",
          borderBottom: "1px solid #CCCCCC;",
          paddingBottom: "10px",
          height: 75
        },
        additem: {
          display: 'flex',
          justifyContent: 'space-between'
        },
        buttonright:{
          float: "right"
        },
        button:{
          paddingRight: "50px",
          paddingLeft: "50px",
          marginRight: "20px",
          textTransform: 'capitalize',
          fontWeight: 'bold',
          letterSpacing: 0
        },
        body:{
            paddingTop:"10px",
          paddingLeft:"20px",
          fontSize:"13px"
        },
        row1:{
            display:"flex",
            marginBottom:"20px"
        },
        column1:{
            marginRight:"20px"
        },
        column2:{
          color:"#112B42",
         fontSize:"14px"
      },
        marginbottom:{
            marginBottom:"20px",
            marginTop:"20px",
        },
       halftext:
       {
           width:"257px",
           height:"32px",
           background:"#f0f0f0",
           marginRight:"20px",
           paddingLeft:"15px",
           paddingRight:"15px",
           marginTop:"10px",
           marginBottom:"20px",
           
       },
       halftextholder:
       {
           width:"257px",
           height:"32px",
           background:"#f0f0f0",
           marginRight:"20px",
           paddingLeft:"15px",
           paddingRight:"15px",
           marginTop:"10px",
           marginBottom:"20px",
           border:"none",
           color:"#112B42",
           fontSize:"14px",
           outline:"none",
           "&::placeholder": {
             color:"#7F7F7F",
             fontSize:"14px",
             paddingBottom:"15px"
            }
           
       },
       fulltext:
       {
        width:"532px",
        height:"32px",
        background:"#f0f0f0",
        marginRight:"20px",
        paddingLeft:"15px",
        paddingRight:"15px",
        marginTop:"10px",
        marginBottom:"20px"
       },
       fulltextholder:
       {
        width:"532px",
        height:"32px",
        background:"#f0f0f0",
        marginRight:"20px",
        paddingLeft:"15px",
        paddingRight:"15px",
        marginTop:"10px",
        marginBottom:"20px",
        border:"none",
        color:"#112B42",
        outline:"none",
        fontSize:"14px",
        "&::placeholder": {
          color:"#7F7F7F",
          fontSize:"14px",
          paddingBottom:"15px"
         }
       },
       textaddress:{
           background:"#f0f0f0",
           width:"532px",
           height:"115px",
           paddingLeft:"15px",
           paddingRight:"15px",
           marginTop:"10px",
           marginBottom:"20px"
       },
       row2:{
           display:"flex"
       },
       fulldrop:
       {
        width:"532px",
        height:"32px",
        color: '#96A9C3 !important', 
        backgroundColor: '#F4F4F6', 
        marginRight:"20px",
        border:"none",
        paddingLeft:"10px",
        borderRight:"10px solid #f0f0f0",
        marginTop:"10px",
        marginBottom:"20px",
        
       },
      });
      return useStyles();
}